import React, { useState, useEffect } from 'react';
import styles from './Divider.module.css';

const Divider = () => {
    const [blockCount, setBlockCount] = useState(0);

    useEffect(() => {
        const calculateBlockCount = () => {
            const screenWidth = window.innerWidth;
            const blockWidth = window.innerWidth > 768 ? 40 : 30; // 响应式方块大小
            const count = Math.ceil(screenWidth / blockWidth);
            setBlockCount(count);
        };

        calculateBlockCount();
        window.addEventListener('resize', calculateBlockCount);
        
        return () => window.removeEventListener('resize', calculateBlockCount);
    }, []);

    return (
        <div className={styles.divider}>
            {[...Array(blockCount)].map((_, index) => (
                <div key={index} className={styles.block}></div>
            ))}
        </div>
    );
};

export default Divider;
